var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-container"},[_c('el-result',{attrs:{"icon":"warning","title":_vm.$t('notFound.title'),"sub-title":_vm.$t('notFound.subTitle')}},[_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":_vm.goHome}},[_vm._v(_vm._s(_vm.$t("notFound.button")))])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }